
import React from 'react';
import { LegalPageLinks } from '@/components/legal/LegalPageLinks';
import { Helmet } from 'react-helmet-async';
import Footer from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Terms of Service | Rules for Using the Fly Platform</title>
        <meta name="description" content="Read the Fly terms of service to understand the rules for using the platform, what you are responsible for as a user, and how accounts are managed." />
        <meta name="keywords" content="terms of service, user agreement, service terms, platform terms" />
        <link rel="canonical" href="https://www.fly-social.com/terms-of-service" />
      </Helmet>
      {/* Stripped header: Fly logo only, no nav links. Absolute rather than fixed, so on a
          phone it scrolls away instead of sitting on top of the text. */}
      <div className="absolute top-0 left-0 right-0 z-50 px-6 lg:px-10 pt-6 pointer-events-none">
        <a href="/" className="inline-flex items-center pointer-events-auto" aria-label="Fly home">
          <img
            src="/lovable-uploads/2e7bf5aa-9c7b-41ea-b64a-48b87f3dc01d.png"
            alt="Fly"
            className="h-16 md:h-20 drop-shadow-[0_2px_8px_rgba(0,0,0,0.12)]"
          />
        </a>
      </div>
      
      {/* One centred reading column, about 75 characters at prose-lg. */}
      <div className="container mx-auto px-5 pt-28 md:pt-36 pb-16">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight mb-3">Terms of Service</h1>
          <p className="text-gray-600 mb-4">Last updated: 15 May 25</p>

          <div className="prose prose-lg prose-slate max-w-none">
            <h2 className="text-2xl font-semibold mt-8 mb-4">1. Introduction</h2>
            <p>
              Welcome to Fly ("we," "our," or "us"). By accessing or using our services, you agree to be bound by these Terms of Service.
              Please read these terms carefully before using our platform.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">2. Definitions</h2>
            <p>
              "Service" refers to the Fly platform, which helps businesses manage and optimize their Google Business Profiles.
              "User," "you," and "your" refer to individuals or entities using our Service.
              "Content" includes text, images, data, and other materials you provide to us or generate through our Service.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">3. Account Registration</h2>
            <p>
              You must register for an account to use our Service. You agree to provide accurate and complete information when creating your account
              and to update such information to keep it accurate and current. You are responsible for maintaining the confidentiality of your account credentials
              and for all activities that occur under your account.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">4. Service Access and Usage</h2>
            <p>
              Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, and revocable license to access and use our Service.
              You agree not to use our Service for any illegal or unauthorized purpose or in any way that could damage, disable, overburden, or impair our servers or networks.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">5. Intellectual Property</h2>
            <p>
              Our Service and its original content, features, and functionality are owned by ZoomLocal Tech Private Limited and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>
            
          </div>

          <LegalPageLinks current="/terms-of-service" />
        </div>
      </div>
      
      <Footer compact />
    </div>
  );
};

export default Terms;
